import { SignDocTypes, isSignDocComplete } from "../SignDoc/SignDocLib";

export const updateLearningPathOperation = {
    ADD: 'ADD',
    REORDER: 'REORDER',
    REMOVE: 'REMOVE',
    UPDATE: 'UPDATE',
}

export const BEFORE_FIRST_DROP_ZONE_ID = 'before-first'
export const BETWEEN_DROP_ZONE_PREFIX = 'between-'

// HiveComponent status constants
export const HIVE_STATUS = {
    COMPLETED: 'COMPLETED',
    ACTIVE: 'ACTIVE',
    LOCKED: 'LOCKED',
}

// HiveComponent size constants
export const HIVE_SIZE = {
    SMALL: 'SMALL',
    MEDIUM: 'MEDIUM',
    LARGE: 'LARGE',
}

// Learning path item status mapping
export const mapUserSignDocStatusToHiveStatus = (userSignDoc) => {
    if (!userSignDoc) return HIVE_STATUS.LOCKED;

    if (isSignDocComplete({signDoc: userSignDoc})) {
        return HIVE_STATUS.COMPLETED;
    } else if (userSignDoc.viewed || userSignDoc.progressPercent > 0) {
        return HIVE_STATUS.ACTIVE;
    } else {
        return HIVE_STATUS.ACTIVE;
    }
}

export const TabsTypes = {
    courses: [SignDocTypes.REGULAR_COURSE],
    presentations: [SignDocTypes.CANVA_PRESENTATION],
    videos: [SignDocTypes.WATCH_AND_SIGN_VIDEO_FILE, SignDocTypes.WATCH_AND_SIGN_VIMEO_LINK, SignDocTypes.WATCH_AND_SIGN_YOUTUBE_LINK],
    audio: [SignDocTypes.AUDIO_FILE],
    signDocs: [SignDocTypes.READ_AND_SIGN_DOC_PDF],
    links: [SignDocTypes.LINK],
    adminKnowledgeCenter: [SignDocTypes.READ_AND_SIGN_DOC_PDF, SignDocTypes.REGULAR_COURSE, SignDocTypes.WATCH_AND_SIGN_VIMEO_LINK, SignDocTypes.WATCH_AND_SIGN_YOUTUBE_LINK, SignDocTypes.CANVA_PRESENTATION, SignDocTypes.WEEZBEE_COURSE],
    exams: [SignDocTypes.EXAM],
    weezBeeCourses: [SignDocTypes.WEEZBEE_COURSE],
    learningPath: [SignDocTypes.LEARNING_PATH],
    surveys: [SignDocTypes.SURVEY],
    uploads: [SignDocTypes.UPLOAD_DOCUMENT]
}